import { differenceInDays } from "date-fns/differenceInDays";

import { FOURTEEN_DAYS } from "../consts";

/**
 * Whether the order can be reported as damaged or missing
 */
export const orderCanBeReportedBasedOnDeliveryDate = (deliveredAt: number) => {
  return differenceInDays(Date.now(), deliveredAt) <= FOURTEEN_DAYS;
};
